// extracted by mini-css-extract-plugin
module.exports = {"newInterviewBtnWrapper":"InterviewsTable_newInterviewBtnWrapper__11FGE","detailsModalLink":"InterviewsTable_detailsModalLink__983dn"};